import { apiGet } from './httpClient';

export const getCurrentUser = (options) => apiGet('/user/me', options);

export const getCurrentUserPrivileges = (options) => apiGet('/user/me/privileges', options);
